import React from "react";
import { useParams } from "react-router-dom";
import OrderForm from "../Components/OrderForm";

export default function AddOrder() {
  const { userId } = useParams();

  return <OrderForm variant="user" userId={userId} />;
}
